export const isWolfLocal = () => {
    if (process.env.NODE_ENV !== "development") {
        return (window.location.hostname) === "lite.wolfapprove.com"
    }
    return false
}